import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../CSS/ChangePassword.css';

const VerifyEmail = () => {
    const [message, setMessage] = useState('Verifying your email...');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = new URLSearchParams(location.search).get('token');
        if (!token) {
            setMessage('Invalid verification link.');
            return;
        }

        fetch(`https://api.rezepe.com/api/verify-email?token=${token}`)
            .then(res => res.json())
            .then(data => {
                setMessage(data.message);
                setSuccess(data.message.includes('verified'));
            })
            .catch(() => setMessage('An error occurred. Please try again.'));
    }, [location]);

    return (
        <div className="change-password-container">
            <div className="change-password-card">
                <h1>Email Verification</h1>
                <p className={success ? 'success' : 'error'}>{message}</p>
                {success && (
                    <button onClick={() => navigate('/login')}>Go to Login</button>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
